import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Newsletter from '../component/Newsletter';
import { UserGetCart, UserRemoveCart, UserClearCart, UserMajorCartCreation } from '../redux/user/cart/cartServicesSync';
import { InfinitySpin } from 'react-loader-spinner';
import { updateCartRemoveIndicator } from '../redux/user/cart/cartSlices';
import { useNavigate } from 'react-router-dom';
import BrandLogos from '../component/BrandLogos';

const Cart = () => {
  const dispatch = useDispatch();
  const { cart, cartRemoveIndicator } = useSelector((state) => state.user_cart);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(UserGetCart());
  }, [dispatch]);

  const handleQuantityChange = (productId, newQuantity, indicator, quantity) => {
  
    if (quantity <= 1 && indicator === 'minus') return;
    if (quantity <= 0 && indicator === 'plus') return;
    const payload = {
      productId,
      quantity: newQuantity
    };

    dispatch(UserMajorCartCreation(payload))
  };



  const handleRemoveItem = (productId) => {
    dispatch(updateCartRemoveIndicator(productId));
    dispatch(UserRemoveCart({ cartId: productId }));
  };


  const handleClearCart = () => {
    console.log('Clear cart triggered');

    dispatch(UserClearCart()).then((response) => {
      console.log('Clear cart response:', response);
      dispatch(UserGetCart());
    });
  };

  const calculateTotal = () => {
    return cart?.products?.reduce((total, item) => {
      return total + (item.price * item.quantity);
    }, 0) || 0;
  };

  const handleCheckout = () => {
    navigate('/user_dashboard/cart');
  };

  return (
    <main class="main__content_wrapper">
      <section class="breadcrumb__section breadcrumb__bg">
        <div class="container-fluid">
          <div class="row row-cols-1">
            <div class="col">
              <div class="breadcrumb__content">
                <h1 class="breadcrumb__content--title text-white mb-10">
                  Shopping Cart
                </h1>
                <ul class="breadcrumb__content--menu d-flex">
                  <li class="breadcrumb__content--menu__items">
                    <a class="text-white" href="/">Home</a>
                  </li>
                  <li class="breadcrumb__content--menu__items">
                    <span class="text-white">Shopping Cart</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="cart__section section--padding">
        <div class="container-fluid">
          <div class="cart__section--inner">
            <form action="#">
              <h2 class="cart__title mb-40">Shopping Cart</h2>
              <div class="row">
                <div class="col-lg-8">
                  <div class="cart__table">
                    <table className="cart__table--inner">
                      {/* Table Header */}
                      <thead className="cart__table--header">
                        <tr className="cart__table--header__items">
                          <th className="cart__table--header__list">Product</th>
                          <th className="cart__table--header__list">Price</th>
                          <th className="cart__table--header__list">Quantity</th>
                          <th className="cart__table--header__list">Total</th>
                        </tr>
                      </thead>
                      <tbody className="cart__table--body">
                        {cart?.products?.map((item) => (
                          <tr key={item._id} className="cart__table--body__items">
                            <td className="cart__table--body__list">
                              <div className="cart__product d-flex align-items-center">
                                {item.product === cartRemoveIndicator ? (
                                  <InfinitySpin width="80" color="#FE6B30" />
                                ) : (
                                  <button
                                    onClick={() => handleRemoveItem(item.product)}
                                    className="cart__remove--btn flex items-center justify-center"
                                    type="button"
                                  >
                                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16px" height="16px">
                                      <path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z" />
                                    </svg>
                                  </button>
                                )}

                                <div className="cart__thumbnail">
                                  <img src={item.gallery?.[0]?.pic_url} alt={item.product_name} />
                                </div>
                                <div className="cart__content">
                                  <h4 className="cart__content--title">{item.product_name}</h4>
                                </div>
                              </div>
                            </td>
                            <td className="cart__table--body__list">
                              <span className="cart__price">{item.symbol}{item.price}</span>
                            </td>
                            <td className="cart__table--body__list">
                              <div className="quantity__box">
                                <button
                                  type="button"
                                  onClick={() => handleQuantityChange(item.product, - 1, 'minus', item.quantity)}
                                  className="quantity__value decrease"
                                >
                                  -
                                </button>
                                <input
                                  type="number"
                                  value={item?.quantity || 0}
                                  readOnly
                                  className="quantity__number"
                                />
                                <button
                                  type="button"
                                  onClick={() => handleQuantityChange(item.product, 1, 'plus', item.quantity)}
                                  className="quantity__value increase"
                                >
                                  +
                                </button>
                              </div>
                            </td>
                            <td className="cart__table--body__list">
                              <span className="cart__price end">
                                {item.symbol}{(item.price * item.quantity).toFixed(2)}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div
                      class="continue__shopping d-flex justify-content-between"
                    >
                      <a class="continue__shopping--link" href="/shop"
                      >Continue shopping</a
                      >
                      <button onClick={handleClearCart} className="continue__shopping--clear" type="button">
                        Clear Cart
                      </button>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="cart__summary border-radius-10">
                    
                    <div class="cart__note mb-20">
                      <h3 class="cart__note--title">Note</h3>
                      <p class="cart__note--desc">
                        Find below, the sum of your items 
                        as it has been calcluated for you.
                      </p>
                      
                    </div>
                    <div class="cart__summary--total mb-20">
                      <table className="cart__summary--total__table">
                        <tbody>
                          <tr className="cart__summary--total__list">
                            <td className="cart__summary--total__title text-left">SUBTOTAL</td>
                            <td className="cart__summary--amount text-right">
                              ${calculateTotal().toFixed(2)}
                            </td>
                          </tr>
                          <tr className="cart__summary--total__list">
                            <td className="cart__summary--total__title text-left">GRAND TOTAL</td>
                            <td className="cart__summary--amount text-right">
                              ${calculateTotal().toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="cart__summary--footer">
                      <p class="cart__summary--footer__desc">
                        Shipping & taxes calculated at checkout
                      </p>
                      <ul class="d-flex justify-content-between">
                        <li>
                          <button
                            class="cart__summary--footer__btn primary__btn cart"
                            type="submit" onClick={handleCheckout}
                          >
                           Check out
                          </button>
                        </li>
                       
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      <Newsletter />

      <BrandLogos />
    </main>
  )
}

export default Cart